module.exports = __webpack_public_path__ + "static/img/rotate10.8868d94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/horse/rotate10.png
// module id = BJHU
// module chunks = 1